import Enrolment from "./Enrolment";

export default function EnrolmentForm() {
  return (
    <Enrolment reenrol={false} />
  );
};
